import {
    VERIFY_OTP_START,
    VERIFY_OTP_SUCCESS,
    VERIFY_OTP_ERROR
} from '../../constants';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { openHeaderModal } from '../siteadmin/modalActions';
import { closeHeaderModal } from '../siteadmin/modalActions';
import { setRuntimeVariable } from '../runtime';
import { loadAccount } from '../user/account';
import { verifyPhoneNumber as mutation } from '../../lib/graphql';
import { getDeviceId } from '../../core/firebase/firebase';
import history from '../../history';
import { removeCookies } from '../../helpers/Cookies/cookies';

import { setCookies } from '../../helpers/Cookies/cookies';

export function verifyOtp(phoneDialCode, phoneNumber, verificationCode, userType, preferredLanguage, referUrl) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: VERIFY_OTP_START,
            });

            if (!navigator.onLine) {
                showToaster({ messageId: 'networkFailed', toasterType: 'error' })
                return;
            }
            dispatch(setLoaderStart('verifyOtpLoading'));
            const deviceId = await getDeviceId();

            const { data } = await client.mutate({
                mutation,
                variables: {
                    phoneDialCode,
                    phoneNumber,
                    verificationCode: Number(verificationCode),
                    userType,
                    preferredLanguage,
                    deviceId
                },
            });

            if (data?.verifyPhoneNumber?.status === 200) {
                if (data?.verifyPhoneNumber?.result?.auth === '') {
                    await dispatch(openHeaderModal('registerForm'));
                } else {
                    // SECURITY: set the session cookie SERVER-SIDE as httpOnly (XSS can't
                    // read it). Falls back to a client cookie only if the server call fails,
                    // so login is never blocked by a transient hiccup. (secure + sameSite.)
                    {
                        const _token = data?.verifyPhoneNumber?.result?.token;
                        const _ttl = data?.verifyPhoneNumber?.result?.expiresIn;
                        try {
                            const r = await fetch('/auth/session', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                credentials: 'same-origin',
                                body: JSON.stringify({ token: _token, maxAge: _ttl }),
                            });
                            if (!r.ok) throw new Error('session set failed');
                        } catch (e) {
                            setCookies({ name: 'id_token', value: _token, options: { path: '/', maxAge: _ttl, secure: true, sameSite: 'lax' } });
                        }
                    }

                    await dispatch(setRuntimeVariable({
                        name: 'isAuthenticated',
                        value: true,
                    }));
                    await dispatch(closeHeaderModal('loginModal'));
                    await dispatch(closeHeaderModal('verifyPhoneNumber'));
                    await dispatch(loadAccount());
                    history.push(referUrl ? referUrl : '/dashboard');
                }
                dispatch(setLoaderComplete('verifyOtpLoading'));
                dispatch({
                    type: VERIFY_OTP_SUCCESS,
                });
            } else {
                let errorMessage = data?.verifyPhoneNumber?.errorMessage
                await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: errorMessage })

                dispatch({
                    type: VERIFY_OTP_ERROR,
                });
                dispatch(setLoaderComplete('verifyOtpLoading'));
            }
        } catch (error) {
            dispatch({
                type: VERIFY_OTP_ERROR,
            });
            dispatch(setLoaderComplete('verifyOtpLoading'));
            return {
                status: '400'
            };
        }
        return {
            status: '200'
        };
    };
}